import { AIRWAY_BILL_INVOICE, PATCH_ACCEPT_SHIP_ORDER } from "../../../../apis/configuration";
import { OrderReturnModal } from "../../../common/Modals";
import { ParagraphText, UBButton } from "../../../../Libraries";
import OrderCalculation from "../OrderCalculation";
import HeaderItem from "../OrderDetail/HeaderItem";
import useSort from "../../../../hooks/useSort";
import TrackingDetails from "./TrackingDetails";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../../common";
import { useState } from "react";
import { toast } from "react-toastify";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import ListItem from "./ListItem";
import moment from "moment";
import { Box, Grid } from "@mui/material";
import { handleApi } from "../../../../apis";
import { useNavigate } from "react-router-dom";
import fileDownload from "js-file-download";
import styles from "./../OrderDetail/styles.module.css"

const OrderDetail = ({ data }) => {
  const { handleOrderStatus, handleBack, updateLoad, order, I18n } = data || {};

  const {
    return_processing_timestamp,
    supplier_tracking_id,
    created_at_timestamp,
    customer_tracking_id,
    order_status,
    order_number,
    order_detail,
    note,
    id,
  } = order || {};

  const { sort } = useSort() || {};

  const [returnModal, setReturnModal] = useState(false);
  const [printLoad, setPrintLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState();
  const navigate = useNavigate();
  /**
   * Receive toggle to toggle return order modal
   * @returns toggle modal & clear date; 
  */
  const toggleReturnModal = (toggle = false) => {
    setReturnModal(toggle);
    setDate("");
  };

  /**
   * Receive date to change
   * @returns update date state;
  */
  const onChangeText = (value) => setDate(new Date(value));

  /**
   * calling api to accept order
   * @returns update order
  */
  const handleReturnOrder = () =>
    handleOrderStatus(
      PATCH_ACCEPT_SHIP_ORDER,
      {
        shipping_date: Number(date),
        accept: true,
        id,
      },
      true
    ).then(() => {
      toggleReturnModal();
      toast.success("Dispatch date set successfully", { className: 'successToast' });
    });

  /**
   * calling api to ship order
   * @returns update order
  */
  const handleReadyToShip = () => {
    setLoading(true);
    handleOrderStatus(
      PATCH_ACCEPT_SHIP_ORDER,
      {
        ready_to_ship: true,
        id,
      },
      true
    )
      .then(() => toast.success("Order shipped successfully", { className: 'successToast' }))
      .finally(() => setLoading(false));
  };

  /**
  * calling api to download receipt
  * @returns pdf
 */
  const downloadReceipt = () => {
    setPrintLoad(true);
    let params = { order_ids: [id], return: true };
    handleApi(AIRWAY_BILL_INVOICE, params, null, navigate,null, { responseType: "blob" }  )
      .then((res) => {
        fileDownload(res, "Airways.pdf");
        toast.success("PDF downloaded successfully", {
          className: "successToast",
        });
      })
      .catch((err) =>
        toast.error(err?.response?.data?.message || "Something went wrong", {
          className: "errorToast",
        }),
      )
      .finally(() => setPrintLoad(false));
  };

  const RightItemButton = (
    order_status == "pending" ||
      order_status == "received_customer_return"
      ? [
        {
          id: "order_return_detail_btn",
          action: () => {
            if (order_status == "pending") {
              triggerLogEvent(analytics, "sc_order_return_action", { action: "accept", order_number });
              toggleReturnModal(true);
            } else {
              triggerLogEvent(analytics, "sc_order_return_action", { action: "ready_to_ship", order_number });
              handleReadyToShip();
            }
          },
          title:
            order_status == "pending"
              ? I18n.accept_small
              : I18n.ready_to_ship,
          className: "ubSecondaryButton",
          loading,
        },
      ]
      : order_status == "accepted" ||
        order_status == "awaiting_customer_return"
        ? [
          {
            id: "order_return_detail_btn",
            title: `${I18n.delivery_date.toUpperCase()}: ${return_processing_timestamp
              ? moment(new Date(return_processing_timestamp)).format(
                "DD:MMM:YYYY"
              )
              : "-"
              }`,
            className: "ubSecondaryButton",
            action: () => { },
            disabled: true,
            loading,
          },
        ]
        : supplier_tracking_id ?
          [{
            id: "order_return_detail_print_label_btn",
            action: () => {
              triggerLogEvent(analytics, "sc_order_return_action", { action: "print_label", order_number });
              downloadReceipt();
            },
            className: "ubPrimaryButton",
            title: I18n.print_bill,
            disabled: printLoad,
            loading: printLoad,
          }]
          : []
  )

  return (
    <MainContainer fluid>
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: <ParagraphText>
                {`${I18n.order_number} # ${order_number} `}
              </ParagraphText>,
              isBack: true,
              isTitleCase: false
            }}
          >
            {RightItemButton?.length > 0 ?
              RightItemButton.map(item => {
                return (
                  <UBButton
                    id={item.id}
                    title={item.title}
                    className={item.className}
                    style={item.style}
                    onClick={item.action}
                  />
                )
              }) : null}
          </TitleAndActionBox>
          <InnerWrapper className={`innerWrapper newInnerWrapper orderManagementWrapper ${styles.orderDetailWrapper}`}>
            <>

              <div className="orderDetailInnerBox">
                <div className="orderDetailInnerBoxLeft">
                  <HeaderItem I18n={I18n} fromReturn={true} />
                  <div className="orderDetailItemList">
                    {sort(order_detail)?.map((item, index) => (
                      <ListItem key={index} I18n={I18n} item={item} />
                    ))}
                  </div>
                </div>
                <div className="orderDetailInnerBoxRight">
                  <div className="orderDetailCalculationBox">
                    <Box className={styles.orderDetailheader}>
                      <ParagraphText className={"fontSize14 fontWeight500 newFontColor"}>{I18n.order_summary}</ParagraphText>
                    </Box>
                    <OrderCalculation I18n={I18n} order={order} />
                  </div>

                  {customer_tracking_id ? (
                    <TrackingDetails I18n={I18n} order={order} />
                  ) : null}
                  {/* <CustomerDetails I18n={I18n} order={order} /> */}
                </div>
              </div>


              <OrderReturnModal
                header={{ title: "select_dispatch_date" }}
                body={{
                  placeholderText: I18n.select_dispatch_date,
                  toggle: returnModal,
                  toggleReturnModal,
                  selected: date,
                  onChangeText,
                }}
                footer={[{
                  data: {

                    className: "ubSecondaryButton",
                    title: I18n.cancel,
                    onClick: () => toggleReturnModal(),
                    id: `return_cancel`,
                  },
                  data: {
                    disabled: !date ? true : false,
                    onClick: handleReturnOrder,
                    title: I18n.save,
                    className: "ubPrimaryButton",
                  },
                }
                ]}
              />
            </>
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default OrderDetail;
